module Meevo.Plugins.Employee {
    "use strict";

    /**
    * Services Booking Restrictions of Employee 
    */
    export class BookingRestrictionsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.EmployeeBookingRestrictions> {
        public modalService: Components.Modal.IModalService;

        selectedServiceList: any;
        typeAheadBusinessTypeDetailId: any;
        bookingServiceDetail: Model.ServiceDetail;
        public serviceListCriteria: any = {};
        public maxServicesPerDay: number = 0;

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string ) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

            this.dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", {}).then((data) => {
                this.maxServicesPerDay = data.data.appointmentBookSettings.maxNumberOfAppointmentServicesPerEmployeePerDay;
            });

            this.modalService = modalService;
            this.typeAheadBusinessTypeDetailId = identityService.businessTypeId;
            this.identityService = identityService;
        }

        addService(): void {
            if (Model.Guard.isNothing(this.model.servicesList)) {
                this.model.servicesList = [];
            }

            if (Model.Guard.isSomething(this.bookingServiceDetail)
                && _.all(this.model.servicesList, (ec) => { return ec.id !== this.bookingServiceDetail.id })) {
                this.model.servicesList.push(this.bookingServiceDetail);
                this.bookingServiceDetail = undefined;
            }
            this.updatedSelectedServieList();
        }

        removeService(index: number): void {
            if (Model.Guard.isSomething(this.model)) {
                this.model.servicesList.splice(index, 1);
                this.updatedSelectedServieList();
            }
        }

        updatedSelectedServieList(): void {
            this.selectedServiceList.coBusinessTypeId = this.identityService.businessTypeId;
            this.selectedServiceList.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
            this.selectedServiceList = Model.Guard.isNothing(this.model) || Model.Guard.isNothing(this.model.servicesList) || this.model.servicesList.length <= 0
                ? { ExcludeIdList: [this.model.id] }
                : { ExcludeIdList: _.union(_.pluck(this.model.servicesList, 'id'), [this.model.id]) };
        }

        get getMaxServicePerDayLimit(): number {
            return this.model.servicesPerDay === 0 ? 9 : this.model.servicesPerDay;
        }

        get minutes(): any {
            return _.range(0, 495, 15);
        }

        get maxMinutes(): any {
            let maxMinutes = Model.Guard.isNothing(this.model.minutesPerDay) || this.model.minutesPerDay === 0 ? 495 : this.model.minutesPerDay + 15;
            return _.range(0, maxMinutes, 15);
        }

        formatMinutes(totalMinutes: number) {
            let hours = Math.floor(totalMinutes / 60);
            let minutes = totalMinutes % 60;

            let result = '';

            if (hours > 0) {
                result += hours == 1 ? `${hours} hour` : `${hours} hours`;
                if (minutes > 0) {
                    result += ' and ';
                }
            }

            if (minutes > 0) {
                result += minutes == 1 ? `${minutes} minute` : `${minutes} minutes`;
            }

            return result;
        }
    }
}